<template>
  <div class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">待出库区</span>
    </div>
    <div v-if="show_success" class="success ml100">
      <h2 class="mt100 f26 ">您的出库单信息已上传完整,出库单号为：{{out_code}},请到出库列表中上传外标及快递标！</h2>
      <div class="mt50">
        <router-link to="/zhongzhuanbuhuo/stock" class="ivu-btn ivu-btn-primary ml100" tag="span">返回库存</router-link>
        <router-link to="/zhongzhuanbuhuo/out" class="ivu-btn ivu-btn-primary ml50" tag="span">前往出库单列表</router-link>
      </div>
    </div>
    <div v-else class="bg-gray p20">
      <div class="mt20 mb20">
        子账户编号: &nbsp;&nbsp;{{client_name_code}}
      </div>
      <div class="table-box">
        <table>
          <tr>
            <th width="20%">入库单号</th>
            <th width="25%">快递单号</th>
            <th width="10%">内含SKU数</th>
            <th width="10%">内含商品数</th>
            <th width="15%">入库时间</th>
            <th width="20%">操作</th>
          </tr>
          <tr v-if="!list.length">
            <td colspan="6">暂无数据</td>
          </tr>
          <tr v-else v-for="(item,index) in list">
            <td>{{item.in_bill_no}}</td>
            <td>
              {{item.waybill}}
            </td>
            <td>
              {{item.sku_count || 0}}
            </td>
            <td>
              {{item.product_count || 0}}
            </td>
            <td>
              {{item.create_date}}
            </td>
            <td>
              <a class="blue" @click="remove(item.in_bill_no)">移出待出库区</a>
            </td>
          </tr>

        </table>
      </div>
      <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
      <div class="fr mt30">
        <button class="ivu-btn ivu-btn-primary" @click="createOut">创建出库单</button>
      </div>
    </div>

    <Modal v-model="show_sku" width="400">
      <div class="sku-sign p10 f14">
        <img width="240" height="80" :src="bar_code" />
        <p>{{sku.product_name}}</p>
        <p>New</p>
      </div>

      <div slot="footer" class="tc">
        <button class="ivu-btn ivu-btn-primary" @click="show_sku=false">关闭</button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging
    },
    data() {
      return {
        show_success: false,
        list: [],
        client_name_code: '',
        screen_data: {
          client_code: '',
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        bar_code: '', //条形码
        sku: {}, //sku
        show_sku: false,
        out_code:'',//出库单号
      }
    },
    methods: {
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        if (!this.screen_data.client_code) {
          this.list = []
          return false;
        }
        this.$axios.get("/warehouse/in/out/pending", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.list = res.data;
          } else {
            this.list = []
          }
          // this.page_data.pageTotal = res.pageTotal;
          // this.page_data.dataTotal = res.totalSize;
        })
      },
      remove(in_bill_no) { //移除待出库区
        this.$axios.delete('/warehouse/in/out/pending', {
          params: {
            in_bill_no: in_bill_no
          }
        }).then((data) => {
          if (data.success) {
            this.$Message.success('移出成功');
            this.getList()
            this.getPendingCount()
          }
        })
      },
      createOut() { //创建出库单
        this.$axios.post("/WarehouseOut/bill/pending/confirm/zhongzhuan" ,this.$qs.stringify({
          client_code : localStorage.getItem('client_code'),
          warehouse_id: localStorage.getItem('warehouse_id')
        }))
          .then(res => {
            if(res.success){
              this.out_code = res.data
              this.show_success = true
            }
          });
      }
    },
    created() {
      this.client_name_code = localStorage.getItem('client_name_code') || ''
      this.screen_data.client_code = localStorage.getItem('client_code') || ''
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id') || ''
      this.screen_data.biz_type = 0;
      if (!this.screen_data.warehouse_id) {
        this.$Message.info('请选择仓库');
        return false
      }
      if (!this.screen_data.client_code) {
        this.$Message.info('请选择子账户');
        return false
      }
      this.getList()
    }
  }
</script>

<style>
  .table-box tr,
  .table-box th {
    text-align: center;
  }

  .sku-sign {
    width: 260px;
    height: 140px;
    border: 1px solid #ccc;
    margin: auto;
  }

  .sku-modal .ivu-modal-footer {
    height: 70px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/zhongzhuanbuhuo/stock/wait.out.vue